// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"7f19f813","571":"9fe84c9f","821":"1f7c1832"}[chunkId] + ".chunk.js";
};